import type { Navigation } from "./navigation-readiness-policy";

export function initialNavigation(): {
  readonly navigation: Navigation;
  readonly redirected: boolean;
} {
  const timing = performance
    .getEntriesByType("navigation")
    .find(
      (entry): entry is PerformanceNavigationTiming =>
        entry instanceof PerformanceNavigationTiming,
    );
  let navigation: Navigation = "initial_load";

  if (timing?.type === "reload") navigation = "reload";

  if (timing?.type === "back_forward") navigation = "traverse";

  return { navigation, redirected: (timing?.redirectCount ?? 0) > 0 };
}
